import { BorerShiftDocument } from '../BorerShift/queryBuilder';
import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import {
  bypassDeleted,
  ConfigBuilder,
  doNotAutoSync,
  pull,
  push,
  replicate,
} from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import {
  BorerShiftCrewDocument,
  borerShiftCrewPullModifier,
  borerShiftCrewPullQueryBuilder,
  borerShiftCrewPushQueryBuilder,
} from './queryBuilder';

export function borerShiftCrewFamilyMember(
  configBuilder: ConfigBuilder,
  borerShiftCrew: FamilyMember<BorerShiftDocument>,
): FamilyMember<BorerShiftCrewDocument> {
  const syncConfig = configBuilder<BorerShiftCrewDocument>(RxdbCollectionNameV2.BORER_SHIFT_CREW);
  doNotAutoSync(syncConfig);
  bypassDeleted(syncConfig);

  const pullConfig = pull(syncConfig, borerShiftCrewPullQueryBuilder);
  pullConfig.modifier = borerShiftCrewPullModifier;
  push(syncConfig, borerShiftCrewPushQueryBuilder);

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.BORER_SHIFT_CREW, replicationState, [borerShiftCrew]);
}
